import { Navigate } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth } from "@/store/AuthStore";
import FullLoader from "@/components/base/FullLoader";
import PendingApproval from "@/components/auth/PendingApproval";

// Protege las rutas privadas: solo usuarios autenticados y aprobados pueden entrar.
const AuthGuard = ({ children }: { children: ReactNode }) => {
  const { session, profile, loading } = useAuth();

  if (loading) return <FullLoader label="Verificando sesión..." />;
  if (!session) return <Navigate to="/acceso" replace />;

  // IMPORTANTE: mientras el perfil aún no ha cargado NO se puede dejar pasar.
  // Antes, con el perfil en null, un asesor suspendido/pendiente entraba a su
  // portal (la suspensión no se aplicaba). Ahora se espera a cargar el perfil.
  if (!profile) return <FullLoader label="Cargando tu cuenta..." />;

  // Un asesor pendiente, rechazado o suspendido no accede al panel.
  if (profile.role === "asesor" && profile.approvalStatus !== "approved") {
    return <PendingApproval status={profile.approvalStatus} />;
  }

  return <>{children}</>;
};

export default AuthGuard;